import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { WhatsappService } from '../whatsapp/whatsapp.service';

@Directive({
  selector: '[appWaGroupLink]',
  standalone: true
})
export class WaGroupLinkDirective {

  @Output() groupNameResolved = new EventEmitter<string>();
  @Output() loadingChange = new EventEmitter<boolean>();

  constructor(private el: ElementRef, private whatsappService: WhatsappService) {}

  @HostListener('blur')
  onBlur(): void {
    const link: string = this.el.nativeElement.value;
    if (!link) { return; }

    this.loadingChange.emit(true);
    this.whatsappService.getGroupName(link).subscribe({
      next: (result) => {
        this.groupNameResolved.emit(result.groupName || '');
        this.loadingChange.emit(false);
      },
      error: () => {
        this.groupNameResolved.emit('');
        this.loadingChange.emit(false);
      }
    });
  }
}
